<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<img
  class="logo"
  height="80"
  width="250"
  src="/images/logo.svg"
  alt="Sunset Grill logo">

<div class="content">
  <div class="text">
    <span class="title">Our Story</span>
    <span
      class="subtitle">Sunset Grill is Canada’s number one restaurant destination for the best breakfast and lunch!</span>
    <span class="description">
      Our story is quite simple. In 1985 our founder, Angelo Christou, opened Sunset Grill’s doors for the first time in the Beaches area of Toronto, Ontario. Armed with the basic philosophy that Fresh is Tastiest®, Sunset Grill quickly developed long lineups of loyal customers. With huge popularity and consistent service, it quickly became the place to be for the best breakfast near me.
      <br><br>
      It is said that when something works, don’t change it. After almost 40 years in business, we realize that while the world around us has evolved, our concept and methods have not changed. After all, good food, fast service and a pleasant experience is what a successful restaurant is all about.
    </span>
  </div>
</div>

